<template>
  <mdb-container>
    <error v-if="error" :error="error"/>
    <div v-if="!error">
      <h3 v-if="pageTitle">{{ pageTitle }}</h3>
      <mdb-row>
        <mdb-col v-if="showAddButton" md="2" style="margin-top: auto; margin-bottom: auto;">
          <mdb-btn size="sm" rounded icon="plus-circle" @click="addHandler">{{ addLabel }}</mdb-btn>
        </mdb-col>
        <mdb-col :md="dropdownFilter ? '5' : '9'">
          <mdb-input :disabled="executing" id="search-input" v-model="query"
                     aria-label="Search" label="Search"
                     type="text"
                     ariaDescribedBy="search-button"
                     @keydown.native="searchKeyDown">
            <mdb-btn group slot="append" size="sm" id="search-button" @click="loadData"  icon="search" class="mr-2"/>

            <mdb-btn group slot="append" size="sm" id="clear-button" @click="resetSearch"  icon="minus-square"/>

          </mdb-input>
        </mdb-col>



        <mdb-col v-if="dropdownFilter" md="4">
          <mdb-select :label="filterLabel"
                      @getValue="dropdownChanged"
                      class="gp-mdb-select-parent"
                      required
                      ref="validationSelect"
                      v-model="dropdownValues" validation/>
        </mdb-col>
      </mdb-row>
      <div v-if="totalRows > 0" class="text-left">
        <b><i>{{ showingDisplay }} {{ totalDisplay }}</i></b>
      </div>

      <mdb-pagination circle>
        <mdb-page-nav v-if="pages > 10 && pageRange[0] != 1" @click.native="navTo(1)" prev></mdb-page-nav>
        <mdb-page-item v-for="n in pageRange" v-bind:key="n" :active="n == currentPage" @click.native="navTo(n)">{{ n }}
        </mdb-page-item>
        <mdb-page-nav v-if="pages > 10 && pageRange[9] != pages" @click.native="navTo(pages)" next></mdb-page-nav>
      </mdb-pagination>

      <mdb-tbl v-if="!viewAsCards" bordered class="text-left" hover responsive striped>
        <mdb-tbl-head color="primary-color" textWhite>
          <tr>
            <th v-for="(col,i) in columns" v-if="!col.hidden" v-bind:key="i">{{ col.label }}</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="(row,i) in rows" v-show="!(row.id && deleted.includes(row.id))" v-bind:key="i" class="clickable"
              @click="clickHandler(row)">
            <td v-for="(col,i) in columns" v-if="!col.hidden" v-bind:key="i"
                :class="col.type=='number' ? 'text-right' : (col.type=='image' ? 'text-center' : 'text-left')">
              <span v-if="!col.type">{{ row[col.field] }}</span>
              <span v-if="col.type=='number'">{{ row[col.field] }}</span>
              <span v-if="col.type=='checkbox'">
                <mdb-input :id="'checkbox-'+i" v-model="row[col.field]" disabled type="checkbox"/>
              </span>
              <span v-if="col.type=='avatar'">
                <mdb-chip :src="row[col.field]" waves>{{ row['name'] }}
                </mdb-chip>
              </span>
              <span v-if="col.type=='image' && row[col.field]">
                <img :src="row[col.field]" :width="col.size ? col.size : '100px'"/>
              </span>
              <span v-if="col.type=='badge' && row[col.field]">
                <mdb-badge :color="col.badgeColor ? col.badgeColor : 'success'">{{ row[col.field] }}</mdb-badge>
              </span>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>

      <mdb-row v-if="rows && rows.length>0 && viewAsCards">
        <div v-for="(r,i) in rows" :key="i" class="col-lg-3 col-md-12">
          <a href="" @click.prevent="clickHandler(r)">
            <mdb-card class="mb-4" ecommerce narrow style="min-height: 400px;">
              <mdb-view cascade hover>
                <mdb-card-image :src="r[cardConfig.imageField]"
                                style="background-color: #ffffff;"
                                top
                                waves
                ></mdb-card-image>
                <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>

              </mdb-view>
              <mdb-card-body cascade>
                <div v-if="cardConfig.badge" style="position:absolute; right: 0; top: 0">
                  <mdb-badge color="secondary">{{ r[cardConfig.badge] }}</mdb-badge>
                </div>
                <div>{{ r[cardConfig.textField] }}</div>
                <div v-if="r.tags && r.tags.length>0">
                  <mdb-badge v-for="t in r.tags" :key="t.id" class="mr-2" color="secondary">{{ t.tag }}</mdb-badge>
                </div>
              </mdb-card-body>
            </mdb-card>
          </a>
        </div>
      </mdb-row>

      <mdb-pagination circle class="mb-4">
        <mdb-page-nav v-if="pages > 10 && pageRange[0] != 1" @click.native="navTo(1)" prev></mdb-page-nav>
        <mdb-page-item v-for="n in pageRange" v-bind:key="n" :active="n == currentPage" @click.native="navTo(n)">{{ n }}
        </mdb-page-item>
        <mdb-page-nav v-if="pages > 10 && pageRange[9] != pages" @click.native="navTo(pages)" next></mdb-page-nav>
      </mdb-pagination>
    </div>
  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardImage,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbFormInline,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbPageItem,
  mdbPageNav,
  mdbPagination,
  mdbRow,
  mdbSelect,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbView
} from 'mdbvue';
import Error from '../common/Error'

export default {
  name: 'DataTable',
  components: {
    mdbBadge,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbContainer,
    mdbFormInline,
    mdbIcon,
    mdbInput,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbPagination,
    mdbPageNav,
    mdbPageItem,
    mdbChip,
    mdbCard,
    mdbCardImage,
    mdbView,
    mdbMask,
    mdbCardBody,
    mdbSelect,
    Error

  },
  computed: {
    executing: function () {
      return this.$store.state.executing
    },
    reloadTable: function() {
      return this.$store.state.dataTableReloadEvent
    },
    updateTableRow: function() {
      return this.$store.state.updateTableRow
    },
    insertTableRow: function() {
      return this.$store.state.insertTableRow
    },
    deleteTableRow: function() {
      return this.$store.state.deleteTableRow
    }
  },
  props: {
    pageTitle: {
      type: String,
      default: null
    },
    dataSource: {
      type: String,
      default: null
    },
    columns: {
      type: Array,
      default: null
    },
    deleted: {
      type: Array,
      default: function () {
        return []
      }
    },
    clickHandler: {
      type: Function,
      default: function (id) {

      }
    },
    dropdownFilter: {
      type: Boolean,
      default: false
    },
    dropdownValues: {
      type: Array,
      default: null
    },
    showAddButton: {
      type: Boolean,
      default: false
    },
    viewAsCards: {
      type: Boolean,
      default: false
    },
    cardConfig: {
      type: Object,
      default: null
    },
    addHandler: {
      type: Function,
      default: function (id) {

      }
    },
    tableId: {
      type: String,
      default: "default-table"
    },
    addLabel: {
      type: String,
      default: "Create New"
    },
    filterLabel: {
      type: String,
      default: "Filter"
    }
  },
  data() {
    return {
      error: null,
      totalRows: 0,
      rows: [],
      offset: 0,
      showingDisplay: "",
      totalDisplay: "",
      query: "",
      isTyping: false,
      pages: 0,
      filterValue: null,
      currentPage: 1,
      pageRange: []
    };
  },
  mounted() {
    if (this.dropdownValues) {
      for (let d of this.dropdownValues) {
        if (d.selected) this.filterValue = d.value
      }
    }
    this.loadData()
    if (this.pageTitle) document.title = this.pageTitle
  },
  watch: {
    reloadTable: function(value) {
      if (value) {
        this.loadData()
        this.$store.dispatch("setDataTableReload",false)
      }
    },
    insertTableRow: function(value) {
      if (value && value.tableId == this.tableId) {
        this.rows.unshift(value.data)
        this.$store.dispatch("insertTableRow",null)
      }
    },
    updateTableRow: function(value) {
      if (value && value.data && value.tableId == this.tableId) {
        for (let i=0; i<=this.rows.length; i++) {
          if (this.rows[i] && this.rows[i].id == value.data.id) {
            this.rows[i] = value.data
          }
        }
        this.$store.dispatch("updateTableRow", null)
      }
    },
    deleteTableRow: function(value) {
      let loc = -1
      if (value && value.data && value.tableId == this.tableId) {
        for (let i=0; i<=this.rows.length; i++) {
          if (this.rows[i] && this.rows[i].id == value.data.id) {
            loc = i
          }
        }
        if (loc>-1) this.rows.splice(loc,1)
        this.$store.dispatch("updateTableRow", null)
      }
    }
  },
  methods: {
    searchKeyDown(n) {
      if (n.keyCode == 13 && this.query) this.loadData()
    },
    resetSearch() {
      this.query = ""
      this.filterValue = null
      this.loadData()
    },
    dropdownChanged(n) {
      this.filterValue = n
      this.loadData()
    },
    navTo: function (n) {
      this.currentPage = n
      this.offset = (n - 1) * 25
      this.loadData()
    },
    calculatePagination: function () {
      this.pageRange = []
      if (this.pages == 1) return
      let rangeStart = 0
      if (this.pages <= 10) {
        rangeStart = 1
      } else {
        rangeStart = this.currentPage - 1
        if (rangeStart + 10 > this.pages) rangeStart = this.pages - 9
      }
      if (rangeStart < 1) rangeStart = 1
      let max = (this.pages > 10 ? 10 : this.pages)
      for (let i = 0; i < max; i++) {
        const p = i + rangeStart
        if (p <= this.pages) this.pageRange.push(p)
      }

    },
    loadData: function () {
      this.$store.dispatch("setExecuting", true)
      this.rows = null
      this.totalRows = 0
      let url = this.dataSource + "?offset=" + this.offset
      if (this.query) {
        url += "&q=" + escape(this.query)
      }
      if (this.filterValue) url+= "&filter=" + this.filterValue

      api.get(url, {}).then(
          (response) => {
            this.rows = response.data.rows
            this.totalRows = response.data.total
            if (!this.totalRows) this.totalRows = 0
            if (this.totalRows == this.rows.length) {
              this.showingDisplay = "Showing all rows"
              this.totalDisplay = " (" + this.totalRows + ")"
            } else {
              const start = (this.offset + 1)
              let end = (start + 24)
              if (this.rows.length < 25) end = (this.rows.length + this.offset)
              this.showingDisplay = "Showing rows " + start + " - " + end
              this.totalDisplay = " of " + this.totalRows
            }
            if (this.totalRows <= 25) this.pages = 1
            else {
              this.pages = Math.round(this.totalRows / 25)
              if ((this.pages * 25) < this.totalRows) this.pages++
            }
            this.calculatePagination()

          },
          (error) => {
            if (error.response.status == 403) {
              this.$router.push("/403")
            } else {
              this.error = error
            }
          }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
        this.$nextTick().then(() => {
          let el = document.getElementById("search-input");
          if (el) {
            el.focus();
            el.setSelectionRange(el.value.length, el.value.length)
          }
        })
      });

    },
    refresh: function () {
      this.loadPage()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable {
  cursor: pointer;
}
</style>
